const ChemicalInventoryReconciliation = () =>
  import("../../components/chemtracker/ChemicalInventoryReconciliation.vue");
const ReconciliationChemicalContainersTable = () =>
  import(
    "../../components/chemtracker/chemical_inventory_reconciliation/ReconciliationChemicalContainersTable.vue"
  );
const ReconciliationSelections = () =>
  import(
    "../../components/chemtracker/chemical_inventory_reconciliation/Selections.vue"
  );
const ReconciliationSummary = () =>
  import(
    "../../components/chemtracker/chemical_inventory_reconciliation/ReconciliationSummary.vue"
  );
const NotFound = () => import("../../components/NotFound.vue");

const routes = [
  {
    path: "/raft/chemtracker/reconciliation",
    component: ChemicalInventoryReconciliation,
    props: true,
    children: [
      {
        path: "/raft/chemtracker/reconciliation/add",
        component: ReconciliationSelections,
        name: "Selections",
        props: true,
      },
      {
        path: "/node/:groupNid(\\d+)/chemtracker/reconciliation/add",
        component: ReconciliationSelections,
        name: "SelectionsGroup",
        props: true,
      },
      {
        path: "/raft/chemtracker/reconciliation/:recId(\\d+)",
        component: ReconciliationChemicalContainersTable,
        name: "reconciliationTable",
        props: true,
      },
      {
        path: "/node/:groupNid(\\d+)/chemtracker/reconciliation/:recId(\\d+)",
        component: ReconciliationChemicalContainersTable,
        name: "reconciliationTableGroup",
        props: true,
      },
      // If step is < 1000 go to reconciliation page.
      // If step >= 1000, show finalized, summary view.
      {
        path: "/raft/chemtracker/reconciliation/:recId(\\d+)/:recState([0-9]{3})",
        component: ReconciliationChemicalContainersTable,
        name: "reconciliationTableStatus",
        props: true,
      },
      {
        path: "/node/:groupNid(\\d+)/chemtracker/reconciliation/:recId(\\d+)/:recState([0-9]{3})",
        component: ReconciliationChemicalContainersTable,
        name: "reconciliationTableStatusGroup",
        props: true,
      },
      {
        path: "/raft/chemtracker/reconciliation/:recId(\\d+)/:recState([1-9][0-9]{3})",
        component: ReconciliationSummary,
        name: "reconciliationSummary",
        props: true,
      },
      {
        path: "/node/:groupNid(\\d+)/chemtracker/reconciliation/:recId(\\d+)/:recState([1-9][0-9]{3})",
        component: ReconciliationSummary,
        name: "reconciliationSummaryGroup",
        props: true,
      },
      {
        path: "/raft/chemtracker/reconciliation/js/404",
        component: NotFound,
        name: "chemicalInventoryReconciliationNotFound",
      },
      {
        path: "/node/:groupNid(\\d+)/chemtracker/reconciliation/js/404",
        component: NotFound,
        name: "chemicalInventoryReconciliationNotFound",
      },
    ],
  },
];

const globalComponents = {};

export {
  routes as chemicalInventoryReconciliationRoutes,
  globalComponents as chemicalInventoryReconciliationGlobalComponents,
};
